import { camelizeKeys } from '~/redux/api/transformers/utils';
import { everest } from '~/services/serviceInstances';
import { WorkflowContractType } from '~/types/Workflow';

import { DataWrapper } from '../../ApiTypes';

export const getWorkflowContractTypes = async () => {
  const contractTypes =
    await everest.get<DataWrapper<WorkflowContractType[]>>('/contract-types');

  return contractTypes.data.map((item) => camelizeKeys(item));
};
